import columns from "./columns";

import formFields from "./supplierFormFields";
import previewFields from "./previewFields";
import profileFields from "./profileFields";

export default {
    entityName: "organizations",
    pageTitle: "Clients",
    displayName: "clients",
    columns,
    searchPlaceholder: "e.g. name:savola",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
    profileFields,
};
